import { useContext, useState, useEffect } from 'react'
import { ConfiguratorContext } from '../../Contexts/Configuration'
import { NavigationNode } from '../../Services/Navigation'
import { validateAlphaString, validateCap, validateProvince } from '../../Services/Validation'
import ViewType from '../../Types/ViewType'
import './SecondDataPageView.css'
import { Picker } from "@react-native-picker/picker";
import Radio from '../../../../Components/Radio/Radio'
import API from "../../Services/API"

const SecondDataPageView = () => {
	let context = useContext(ConfiguratorContext)

	let [provinces, setProvinces] = useState<string[]>(context.provincesList ? context.provincesList : []);
	let [municipalities, setMunicipalities] = useState<string[]>(context.secondMunicipalitiesList ? context.secondMunicipalitiesList : []);
	let [caps, setCaps] = useState<string[]>(context.capsList ? context.capsList : []);

	let [billingProvinces, setBillingProvinces] = useState<string[]>([]);
	let [billingMunicipalities, setBillingMunicipalities] = useState<string[]>([]);
	let [billingCaps, setBillingCaps] = useState<string[]>([]);

	let [address, setAddress] = useState(context.address)
	let [addressError, setAddressError] = useState("")

	let [isBillingEqual, setIsBillingEqual] = useState<boolean>(true)

	let [billingAddress, setBillingAddress] = useState(context.billingAddress)
	let [billingAddressError, setBillingAddressError] = useState("")

	let [number, setNumber] = useState(context.civicNumber)
	let [numberError, setNumberError] = useState("")

	let [billingNumber, setBillingNumber] = useState(context.billingCivicNumber)
	let [billingNumberError, setBillingNumberError] = useState("")

	let [cap, setCap] = useState(context.cap)
	let [capError, setCapError] = useState("")

	let [billingCap, setBillingCap] = useState(context.billingCap)
	let [billingCapError, setBillingCapError] = useState("")

	let [common, setCommon] = useState(context.common)
	let [commonError, setCommonError] = useState("")

	let [billingMunicipality, setBillingMunicipality] = useState(context.billingMunicipality)
	let [billingMunicipalityError, setBillingMunicipalityError] = useState("")

	let [province, setProvince] = useState(context.province)
	let [provinceError, setProvinceError] = useState("")

	let [billingProvince, setBillingProvince] = useState(context.billingProvince)
	let [billingProvinceError, setBillingProvinceError] = useState("")

	context.validateSecondDataPage = () => {
		const validAddress = address !== undefined && address?.length > 0
		setAddressError(validAddress ? "" : "Inserisci l'indirizzo")

		const validNumber = number !== undefined && number?.length > 0
		setNumberError(validNumber ? "" : "Inserisci il numero civico")

		const validCap = validateCap(cap ?? "")
		setCapError(validCap ? "" : "Seleziona un CAP")

		const validCommon = validateAlphaString(common ?? "")
		setCommonError(validCommon ? "" : "Seleziona un comune")

		const validProvince = validateProvince(province ?? "")
		setProvinceError(validProvince ? "" : "Seleziona una provincia")

		const validBillingAddress = billingAddress !== undefined && billingAddress?.length > 0
		setBillingAddressError(validBillingAddress ? "" : "Inserisci l'indirizzo di fatturazione")

		const validBillingNumber = billingNumber !== undefined && billingNumber?.length > 0
		setBillingNumberError(validBillingNumber ? "" : "Inserisci il numero civico di fatturazione")

		const validBillingCap = validateCap(billingCap ?? "")
		setBillingCapError(validBillingCap ? "" : "Seleziona un CAP di fatturazione")

		const validBillingMunicipality = validateAlphaString(billingMunicipality ?? "")
		setBillingMunicipalityError(validBillingMunicipality ? "" : "Seleziona un comune di fatturazione")

		const validBillingProvince = validateProvince(billingProvince ?? "")
		setBillingProvinceError(validBillingProvince ? "" : "Seleziona una provincia di fatturazione")

		context.address = address?.trim()
		context.civicNumber = number?.trim()
		context.cap = cap?.trim()
		context.common = common?.trim()
		context.province = province?.trim()

		if (isBillingEqual) {
			context.billingAddress = address?.trim()
			context.billingCivicNumber = number?.trim()
			context.billingCap = cap?.trim()
			context.billingMunicipality = common?.trim()
			context.billingProvince = province?.trim()
		} else {
			context.billingAddress = billingAddress?.trim()
			context.billingCivicNumber = billingNumber?.trim()
			context.billingCap = billingCap?.trim()
			context.billingMunicipality = billingMunicipality?.trim()
			context.billingProvince = billingProvince?.trim()
		}

		context.secondMunicipalitiesList = municipalities
		context.capsList = caps

		if (isBillingEqual) {
			return validAddress && validNumber && validCap && validCommon && validProvince
		} else {
			return validAddress && validNumber && validCap && validCommon && validProvince
				&& validBillingAddress && validBillingNumber && validBillingCap && validBillingMunicipality && validBillingProvince
		}
	}

	useEffect(() => {
		(async () => {
			let p = await API.getProvincesAsync();
			if (p.success) {
				setProvinces(p.data);
				setBillingProvinces(p.data)
			}
			getMunicipalitiesByProvince(context.province)
			getBillingMunicipalitiesByProvince(context.billingMunicipality)

			getCapsByMunicipality(context.province, context.common)
			getBillingCapsByMunicipality(context.billingProvince, context.billingMunicipality)

		})()
		return () => { }
	}, [])

	const getMunicipalitiesByProvince = async (province?: string) => {
		let o = await API.getMunicipalitiesAsync(province);
		if (o.success) {
			setMunicipalities(o.data);
		}
	}

	const getBillingMunicipalitiesByProvince = async (province?: string) => {
		let o = await API.getMunicipalitiesAsync(province);
		if (o.success) {
			setBillingMunicipalities(o.data);
		}
	}

	const getCapsByMunicipality = async (province?: string | undefined, municipality?: string) => {
		let o = await API.getCapsAsync(province, municipality);
		if (o.success) {
			setCaps(o.data);
		}
	}

	const getBillingCapsByMunicipality = async (province?: string | undefined, municipality?: string) => {
		let o = await API.getCapsAsync(province, municipality);
		if (o.success) {
			setBillingCaps(o.data);
		}
	}

	function getBillingDataInput() {
		if (!isBillingEqual) {
			return (
				<div className="second-data-page-billing-container">
					<div>
						<div className="second-page-label-question">Indirizzo di fatturazione</div>
						<input onChange={a => setBillingAddress(a.target.value)} value={billingAddress} className="second-data-page-input" />
						<div className='label-error'>{billingAddressError}</div>
					</div>
					<div>
						<div className="second-page-label-question">Numero civico di fatturazione</div>
						<input onChange={n => setBillingNumber(n.target.value)} value={billingNumber} className="second-data-page-input" />
						<div className='label-error'>{billingNumberError}</div>
					</div>
					<div>
						<div className="second-page-label-question">Provincia di fatturazione</div>
						<Picker
							style={{ height: "50px", width: "100%", backgroundColor: "#404998", borderColor: "white", borderStyle: "solid", borderWidth: 1, color: "white", fontSize: 20 }}
							selectedValue={billingProvince}
							onValueChange={async (itemValue) => {
								setBillingProvince(itemValue);
								await getBillingMunicipalitiesByProvince(itemValue);
							}
							}>
							<Picker.Item key='' label='-- Seleziona una Provincia --' value='' />
							{
								billingProvinces.map((p) => {
									return <Picker.Item key={p} label={p} value={p} />;
								})
							}
						</Picker>
						<div className='label-error'>{provinceError}</div>
					</div>
					<div>
						<div className="second-page-label-question">Comune di fatturazione</div>
						<Picker
							style={{ height: "50px", width: "100%", backgroundColor: "#404998", borderColor: "white", borderStyle: "solid", borderWidth: 1, color: "white", fontSize: 20 }}
							selectedValue={billingMunicipality}
							onValueChange={async (itemValue) => {
								setBillingMunicipality(itemValue);
								await getBillingCapsByMunicipality(billingProvince, itemValue);
							}
							}>
							<Picker.Item key='' label='-- Seleziona un Comune --' value='' />
							{
								billingMunicipalities.map((m) => {
									return <Picker.Item key={m} label={m} value={m} />;
								})
							}
						</Picker>
						<div className='label-error'>{billingMunicipalityError}</div>
					</div>
					<div>
						<div className="second-page-label-question">Cap di fatturazione</div>
						<Picker
							style={{ height: "50px", width: "100%", backgroundColor: "#404998", borderColor: "white", borderStyle: "solid", borderWidth: 1, color: "white", fontSize: 20 }}
							selectedValue={billingCap}
							onValueChange={async (itemValue) => {
								setBillingCap(itemValue);
							}
							}>
							<Picker.Item key='' label='-- Seleziona un CAP --' value="" />
							{
								billingCaps.map((c) => {
									return <Picker.Item key={c} label={c} value={c} />;
								})
							}
						</Picker>
						<div className='label-error'>{billingCapError}</div>
					</div>
				</div>
			)
		}
	}

	return (
		<div className="second-data-page-container">
			<div className='label-error' style={{ fontSize: '25px' }}>{addressError || numberError || capError || commonError || provinceError ? "E' necessario compilare tutti i campi obbligatori" : ""}</div>
			<div>
				<div className="second-page-label-question">Indirizzo di copertura segnale Internet</div>
				<input onChange={a => setAddress(a.target.value)} value={address} className="second-data-page-input" />
				<div className='label-error'>{addressError}</div>
			</div>
			<div>
				<div className="second-page-label-question">Numero civico</div>
				<input onChange={n => setNumber(n.target.value)} value={number} className="second-data-page-input" />
				<div className='label-error'>{numberError}</div>
			</div>
			<div>
				<div className="second-page-label-question">Provincia</div>
				<Picker
					style={{ height: "50px", width: "100%", backgroundColor: "#404998", borderColor: "white", borderStyle: "solid", borderWidth: 1, color: "white", fontSize: 20 }}
					selectedValue={province}
					onValueChange={async (itemValue) => {
						setProvince(itemValue);
						await getMunicipalitiesByProvince(itemValue);
					}
					}>
					<Picker.Item key='' label='-- Seleziona una Provincia --' value='' />
					{
						provinces.map((province) => {
							return <Picker.Item key={province} label={province} value={province} />;
						})
					}
				</Picker>
				<div className='label-error'>{provinceError}</div>
			</div>
			<div>
				<div className="second-page-label-question">Comune</div>
				<Picker
					style={{ height: "50px", width: "100%", backgroundColor: "#404998", borderColor: "white", borderStyle: "solid", borderWidth: 1, color: "white", fontSize: 20 }}
					selectedValue={common}
					onValueChange={async (itemValue) => {
						setCommon(itemValue);
						await getCapsByMunicipality(province, itemValue);
					}
					}>
					<Picker.Item key='' label='-- Seleziona un Comune --' value='' />
					{
						municipalities.map((municipality) => {
							return <Picker.Item key={municipality} label={municipality} value={municipality} />;
						})
					}
				</Picker>
				<div className='label-error'>{commonError}</div>
			</div>
			<div>
				<div className="second-page-label-question">Cap</div>
				<Picker
					style={{ height: "50px", width: "100%", backgroundColor: "#404998", borderColor: "white", borderStyle: "solid", borderWidth: 1, color: "white", fontSize: 20 }}
					selectedValue={cap}
					onValueChange={async (itemValue) => {
						setCap(itemValue);
					}
					}>
					<Picker.Item key='' label='-- Seleziona un CAP --' value="" />
					{
						caps.map((cap) => {
							return <Picker.Item key={cap} label={cap} value={cap} />;
						})
					}
				</Picker>
				<div className='label-error'>{capError}</div>
			</div>

			<div>
				<div className="first-page-label-question">L'indirizzo di fatturazione è uguale a quello di copertura?</div>
				<div className="gender-question">
					<Radio title='Si' onChange={() => setIsBillingEqual(true)} checked={isBillingEqual} />
					<Radio title='No' onChange={() => setIsBillingEqual(false)} checked={!isBillingEqual} />
				</div>
			</div>

			{getBillingDataInput()}

			<div style={{ minHeight: "20px" }} />
		</div>
	)
}

const SecondDataPageNode: NavigationNode = {
	content: () => <SecondDataPageView />,
	previous: () => ViewType.enterEmail,
	next: () => ViewType.offers,
	percentage: 54
}

export default SecondDataPageNode
